export default "__VITE_PUBLIC_ASSET__c90b1135__"